<h1> CALL FOR WORKSHOPS </h1>

<p>
	In the morning of the 27-th of September 2024, our Congress will host many workshops, lasting either two or
	four hours.
</p>
<h2> PROPOSALS </h2>
<p>
	Worksop proposals must be submitted to <a href="mailto:cifris24@decifris.it">cifris24&#64;decifris.it</a>. The
	deadline for proposals is <b>May 2024</b>.
</p>
<p>
	The proposal description must contain:
</p>
<ul>
	<li> A name for the workshop; </li>
	<li> A description for the workshop aim and subject; </li>
	<li> At least two names of organizers; </li>
	<li> A tentative workshop structure; </li>
	<li> The name of the invited speaker. </li>
</ul>

<h2> TOPICS </h2>
<p>
	Any subject related to cryptography and its applications is welcome.
</p>
<p>
	Besides those listed in the <a href="/cifris24/call-for-papers">call for papers</a>,
	we also accept proposals related to the interaction of cryptography with society in a broad sense, such as
	legal aspects, socio-economic implications, privacy/digital rights of citizens, hacking community, etc.
</p>

<h2> ACCEPTANCE </h2>
<p>
	Accepted workshops will be notified within July 2024.
</p>
<p>
	All workshop talks will be included, as 2-page mini-abstracts, in the Congress Proceedings and might thus be
	published in full form by the workshop organizers in other venues without any consent by De Cifris. All
	workshop participants must pay the Workshop fee. To have access to the full Congress, they will have to pay
	the combined fee.
</p>